import { CarouselImage } from './CarouselImage'

export const SingleColumnCarouselItem = ({
  item,
  imageWidth,
  imageHeight,
}: {
  item: string
  imageWidth: number
  imageHeight: number
}) => (
  <div className='mc-mb-3'>
    <CarouselImage
      className='mc-corners--md'
      key={item}
      src={item}
      width={imageWidth}
      height={imageHeight}
    />
  </div>
)
